import React from 'react';
import { Button, Tooltip, Stack, Box } from '@mui/material';
import * as CommonFunctions from '../../services/CommonFunctions'; // ścieżka przykładowa

const FileUploadCellRenderer = ({
  data,
  uploadedFiles,
  handleFileUpload,
  handleFileRemove,
  darkTheme = false,
  isDeleteAllowed,
  isUploadAllowed,
  token,
}) => {
  const rowId = data?.id ?? null;
  const clientId = data?.clientId ?? null;

  // 🔹 Preferuj lokalny stan (plik świeżo wgrany), a jeśli brak — dane z backendu
  const fileInfo =
    (rowId && uploadedFiles?.[rowId]) || null;

  const inputId = `upload-input-${rowId}`;

  const onFileChange = (e) => {
    const f = e?.target?.files?.[0];
    if (f) handleFileUpload(rowId, clientId, f);
    e.target.value = null; // reset, aby można było wgrać ten sam plik ponownie
  };

  const onDownload = async () => {
    try {
      await CommonFunctions.downloadFile(
        fileInfo.id || fileInfo.fileId, // z backendu lub z lokalnego stanu
        fileInfo.fileType,
        null, null, null,
        token,
        data?.companyName
      );
    } catch (error) {
      console.error('Błąd podczas pobierania pliku:', error);
      // Tu możesz ewentualnie dodać Snackbar w komponencie nadrzędnym
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        whiteSpace: 'nowrap'
      }}
    >
      {!fileInfo ? (
        <>
          {isUploadAllowed && (
            <>
          <input
            id={inputId}
            type="file"
            accept=".xml"
            style={{ display: 'none' }}
            onChange={onFileChange}
          />
          <label htmlFor={inputId} style={{ margin: 0 }}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              component="span"
            >
              Wgraj plik xml
            </Button>
          </label>
          </>
          )}
        </>
      ) : (
        <>
          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              color="success"
              size="small"
              onClick={onDownload}
            >
              Pobierz
            </Button>
            {isDeleteAllowed &&
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => handleFileRemove(rowId, fileInfo)}
              >
                Usuń
              </Button>
            }
          </Stack>
        </>
      )}
    </div>
  );
};

export default FileUploadCellRenderer;